import styled, { css } from 'styled-components';

import { ToggleButton } from './Availability.style';
import { below, above } from '../../styles/libs';

export const PitchToggleButton = styled(ToggleButton)`
  &:first-child {
    margin-top: 0;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 100px;
  gap: 1rem;
`;

export const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  select {
    margin-left: 5px;
    padding-right: 3rem;
  }
  ${({ theme }) => below(theme.TABLET)`
    flex-direction: column;
    align-items: flex-start;

    select {
      margin-left: 0;
    }
  `}
`;

export const PitchPrice = styled.div`
  display: flex;
  flex: 0 1 220px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: auto;

  ${({ theme }) => above(theme.TABLET)`
    flex: 0 1 auto;
    padding-left: 1.25rem;
  `}

  // If we don't have a price, we can give the
  // pitch title and description more space
  ${({ hasPrice }) => !hasPrice && css`
    flex: 0 1 150px;
  `}
`;

export const Price = styled.div`
  margin-left: auto;
  font-size: 0.875rem;
  text-align: right;
`;

export const PriceInformation = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StayInformation = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  justify-content: flex-end;
  margin-top: 0.25rem;
  line-height: 1;
  font-size: 0.8125rem;
`;

export const StayComponentContainer = styled.span`
  white-space: nowrap;
`;
